import { Star, StarHalf } from "lucide-react";
import { cn } from "@/lib/utils";

interface RatingDisplayProps {
  rating: number;
  reviewCount: number;
  showCount?: boolean;
  size?: "sm" | "md" | "lg";
  className?: string;
}

export function RatingDisplay({
  rating,
  reviewCount,
  showCount = true,
  size = "md",
  className
}: RatingDisplayProps) {
  const sizeClasses = {
    sm: "w-3 h-3",
    md: "w-4 h-4",
    lg: "w-5 h-5"
  };

  const textSizes = {
    sm: "text-xs",
    md: "text-sm",
    lg: "text-base"
  };

  // Render stars
  const renderStars = () => {
    const stars = [];
    const fullStars = Math.floor(rating);
    const hasHalfStar = rating % 1 >= 0.5;

    for (let i = 0; i < 5; i++) {
      if (i < fullStars) {
        stars.push(
          <Star
            key={i}
            className={cn("fill-amber-400 text-amber-400", sizeClasses[size])}
          />
        );
      } else if (i === fullStars && hasHalfStar) {
        stars.push(
          <StarHalf
            key={i}
            className={cn("fill-amber-400 text-amber-400", sizeClasses[size])}
          />
        );
      } else {
        stars.push(
          <Star
            key={i}
            className={cn("text-slate-300", sizeClasses[size])}
          />
        );
      }
    }
    return stars;
  };

  if (reviewCount === 0) {
    return (
      <div className={cn("flex items-center gap-1", className)}>
        <span className={cn("text-slate-400 italic", textSizes[size])}>
          No reviews yet
        </span>
      </div>
    );
  }

  return (
    <div className={cn("flex items-center gap-1", className)}>
      {renderStars()}
      {showCount && (
        <span className={cn("text-slate-600 font-medium", textSizes[size])}>
          ({reviewCount})
        </span>
      )}
    </div>
  );
}